import { render, staticRenderFns } from "./checkboxes-for-select-column.vue?vue&type=template&id=490e3a2c&scoped=true"
import script from "./checkboxes-for-select-column.vue?vue&type=script&lang=js"
export * from "./checkboxes-for-select-column.vue?vue&type=script&lang=js"
import style0 from "./checkboxes-for-select-column.vue?vue&type=style&index=0&id=490e3a2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e3a2c",
  null
  
)

export default component.exports